<template>
  <div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div
      id="user-data user-card"
      v-if="$route.params.id && clientDetail"
      v-show="!loading"
    >
      <div class="vx-row mb-base">
        <div class="vx-card pl-6 pr-6" style="min-height: 643px">
          <router-link to="/customers" class="vx-row">
            <h4 class="routepath">
              <span class="primary">
                <feather-icon
                  icon="ArrowLeftIcon"
                  svgClasses="text-dark"
                  class="shift-2"
              /></span>
              <span class="secondary">{{
                $t("customers.label.view_customer")
              }}</span>
            </h4>
          </router-link>
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-full">
              <div class="about-detail">
                <div>
                  <div
                    class="profile-wrapper p-3"
                    :style="{ backgroundColor: profileBgCol }"
                  >
                    <div class="profilePic">
                      <img
                        v-if="profilePic"
                        :src="profilePic"
                        id="avatar-pic"
                        class="profile-image"
                        :style="{ borderColor: categoryColor }"
                      />
                      <img
                        v-else
                        src="@/assets/images/avatar/avatar.png"
                        id="avatar-pic"
                        class="profile-image"
                        :style="{ borderColor: categoryColor }"
                      />
                    </div>
                    <div>
                      <div
                        class="dark-label mt-5 text-center"
                        style="font-size: 11px; color: #000000"
                      >
                        {{ clientDetail.accountNumber }}
                      </div>
                      <div
                        class="mt-1"
                        style="padding: 5px; color: #000000"
                        v-if="clientDetail && clientDetail.clientCategory"
                      >
                        <vs-chip :color="categoryColor" class="category-chip"
                          >{{
                            (clientDetail && clientDetail.clientCategory) || ""
                          }}
                        </vs-chip>
                      </div>
                      <div
                        v-if="
                          clientDetail &&
                          clientDetail.billingInfo &&
                          clientDetail.billingInfo.type
                        "
                        class="mt-5"
                        style="padding: 5px; color: #000000"
                      >
                        <vs-chip class="category-chip" :color="categoryColor"
                          >{{
                            clientDetail &&
                            clientDetail.billingInfo &&
                            clientDetail.billingInfo.type
                          }}
                        </vs-chip>
                      </div>
                    </div>
                  </div>
                  <div
                    class="text-left pl-3"
                    style="font-weight: 600; font-size: 15px; color: #000000"
                  >
                    {{
                      clientDetail &&
                      clientDetail.personalInfo &&
                      clientDetail.personalInfo.title
                    }}
                    {{
                      clientDetail &&
                      clientDetail.personalInfo &&
                      clientDetail.personalInfo.firstName
                    }}
                  </div>
                </div>
                <vs-divider />
                <div class="p-1">
                  <table>
                    <tr>
                      <td class="vx-col dark-label">
                        {{ $t("customers.label.business_entity") }}:
                      </td>
                      <td class="vx-col dark-label">
                        <vx-tooltip
                          :text="clientDetail.accountInfo.office.hierarchy"
                          color="primary"
                        >
                          <span>{{
                            (
                              (clientDetail &&
                                clientDetail.accountInfo &&
                                clientDetail.accountInfo.office &&
                                clientDetail.accountInfo.office.hierarchy) ||
                              ""
                            ).split("->")[0]
                          }}</span>
                        </vx-tooltip>
                      </td>
                    </tr>
                    <div
                      v-for="item in uniqueItems"
                      :key="item.id"
                      style="display: flex; flex-direction: column"
                    >
                      <td class="vx-col dark-label">
                        <span v-if="item && item.itemCode === 'MSISDN'"
                          >{{ item && item.itemCode }}:</span
                        >
                      </td>
                      <td class="vx-col dark-label">
                        <a
                          @click="callCustomer(item.serialNo)"
                          style="cursor: pointer; font-size: 18px"
                          v-if="item.itemCode === 'MSISDN'"
                          >{{ item && item.serialNo }}</a
                        >
                      </td>
                    </div>
                  </table>
                  <div class="vx-row p-1">
                    <div class="vx-col md:w-1/2 w-full light-label pl-4"></div>
                    <div class="vx-col md:w-1/2 w-full dark-label"></div>
                  </div>
                  <div class="vx-row p-1">
                    <div class="vx-col md:w-1/2 w-full light-label pl-4"></div>
                    <div class="vx-col md:w-1/2 w-full dark-label"></div>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-3"
                :class="[{ active: serviceOrderToggle }]"
              >
                <div
                  class="vx-row px-3"
                  @click.stop="
                    togglePage(1);
                    serviceOrderToggle = true;
                  "
                >
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.service_orders") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-3"
                :class="[{ active: transactionToggle }]"
                @click.stop="togglePage(5)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.tickets") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === 'Postpaid'
                "
                class="navigation-button-lay p-3"
                :class="[{ active: PaymentsToggle }]"
                @click.stop="togglePage(8)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.payments") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === 'Postpaid'
                "
                class="navigation-button-lay p-3"
                :class="[{ active: StatementsToggle }]"
                @click.stop="togglePage(12)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.invoice") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-3"
                :class="[{ active: AccountsToggle }]"
                @click.stop="togglePage(7)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("entity.label.financial_transactions") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  clientDetail &&
                  clientDetail.billingInfo &&
                  clientDetail.billingInfo.type === 'Postpaid'
                "
                class="navigation-button-lay p-3"
                :class="[{ active: billCollectionToggle }]"
              >
                <div class="vx-row px-3" @click.stop="togglePage(14)">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.bill_collection_action") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-3"
                :class="[{ active: ActivityToggle }]"
                @click.stop="togglePage(10)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.transaction_history") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <div
                class="navigation-button-lay p-3 mb-2"
                :class="[{ active: moreInfoToggle }]"
              >
                <div class="vx-row px-3" @click.stop="togglePage(2)">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.more_info") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div>
              <!-- <div
                class="navigation-button-lay p-3"
                :class="[{ active: clientBillProfileToggle }]"
              >
                <div class="vx-row px-3" @click.stop="togglePage(13)">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.billProfile") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="navigation-button-lay p-3"
                :class="[{ active: DemandToggle }]"
                @click.stop="togglePage(6)"
              >
                <div class="vx-row px-3">
                  <div class="my-label">
                    <div class="ellipsis">
                      {{ $t("customers.label.on_demand") }}
                    </div>
                  </div>
                  <div style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="navigation-button-lay p-3"
                :class="[{ active: AdjastmentToggle }]"
                @click.stop="togglePage(9)"
              >
                <div class="vx-row">
                  <div class="vx-col">Adjustment</div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="navigation-button-lay p-3"
                :class="[{ active: ChildsToggle }]"
                @click.stop="togglePage(11)"
              >
                <div class="vx-row">
                  <div class="vx-col">Childs</div>
                  <div class="vx-col" style="margin-left: auto">
                    <span> <feather-icon icon="ChevronRightIcon" /></span>
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="navigation-button-lay p-3 mb-8"
                :class="[{ active: ActionsToggle }]"
                @click.stop=""
              ></div> -->
            </div>
            <div class="vx-col md:w-4/5 w-full">
              <Information />
              <div v-if="serviceOrderToggle">
                <ServiceOverview
                  @orderChargingPopup="orderChargingPopup = true"
                  @redeemPopup="redeemPopup = true"
                  @depositPopup="
                    getDepositList();
                    depositPopup = true;
                    errorMessage = '';
                  "
                  @recieverPopup="recieverPopup = true"
                  @openChangePlan="openChangePlan"
                  @renewalPlan="renewalPlan"
                  @deviceOverview="deviceOverviewPopup = true"
                  @swapDevice="swapDevice"
                  @spendCapPopup="showSpendCap"
                  @topUpPopup="openTopUp = true"
                  @renewalPopup="openRenewal = true"
                />
              </div>
              <div v-if="clientBillProfileToggle" class="tab-text">
                <BillProfile :clientId="$route.params.id" />
              </div>
              <div v-if="billCollectionToggle" class="tab-text">
                <CollectionAction :clientId="$route.params.id" />
              </div>
              <div v-if="moreInfoToggle" class="tab-text">
                <more-info :clientId="$route.params.id" />
              </div>
              <div v-if="transactionToggle" class="tab-text">
                <Ticket
                  :clientId="$route.params.id"
                  :refresh="ticketPopup"
                  @openTicket="ticketPopup = true"
                />
              </div>
              <div v-if="DemandToggle" class="tab-text">
                <on-demand :clientId="$route.params.id" />
              </div>
              <div v-if="AccountsToggle" class="tab-text">
                <Accounts
                  @refreshPage="getClient"
                  :clientId="$route.params.id"
                />
              </div>
              <div v-if="PaymentsToggle" class="tab-text">
                <Payments
                  @refreshPage="getClient"
                  :clientId="$route.params.id"
                />
              </div>
              <!-- <div v-if="AdjastmentToggle" class="tab-text">
                <Adjastment
                  @refreshPage="getClient"
                  :clientId="$route.params.id"
                />
              </div> -->
              <div v-if="StatementsToggle" class="tab-text">
                <Statement :clientId="$route.params.id" />
              </div>
              <div v-if="ChildsToggle" class="tab-text">
                <Child :clientId="$route.params.id" />
              </div>
              <div v-if="ActivityToggle" class="tab-text">
                <ActivityLog :clientId="$route.params.id" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Device Overview -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          class="popup-close"
          :title="$t('customers.label.device_overview')"
          :active.sync="deviceOverviewPopup"
        >
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-table
                :max-items="5"
                pagination
                :data="clientDetail.services[0]"
              >
                <template slot="thead">
                  <vs-th>{{ $t("customers.label.service_id") }}</vs-th>
                  <vs-th>{{ $t("customers.label.sale_type") }}</vs-th>
                  <vs-th>{{ $t("customers.label.sale_date") }}</vs-th>
                  <vs-th>{{ $t("customers.label.item_code") }}</vs-th>
                  <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
                  <vs-th>{{ $t("customers.label.charge_code") }}</vs-th>
                  <vs-th>{{ $t("customers.label.quantity") }}</vs-th>
                  <vs-th>{{ $t("customers.label.total_price") }}</vs-th>
                  <vs-th>{{ $t("customers.label.warranty_date") }}</vs-th>
                  <vs-th>{{ $t("customers.label.allocate") }}</vs-th>
                  <vs-th v-if="propertyMaster">{{
                    $t("customers.label.property_code")
                  }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("customers.label.action")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="index" v-for="(device, index) in data.devices">
                    <vs-td :data="device.clientServiceId">{{
                      device && device.clientServiceId
                    }}</vs-td>
                    <vs-td :data="device.saleType">{{
                      device && device.saleType
                    }}</vs-td>
                    <vs-td :data="getDate(device.saleDate)">{{
                      getDate(device && device.saleDate)
                    }}</vs-td>
                    <vs-td :data="device.itemCode">{{
                      device && device.itemCode
                    }}</vs-td>
                    <vs-td :data="device.serialNo">{{
                      device && device.serialNo
                    }}</vs-td>
                    <vs-td :data="device.chargeCode">{{
                      device && device.chargeCode
                    }}</vs-td>
                    <vs-td :data="device.quantity">{{
                      device && device.quantity
                    }}</vs-td>
                    <vs-td :data="device.totalPrice">{{
                      device && device.totalPrice
                    }}</vs-td>
                    <vs-td :data="getDate(device.warrantyDate)">{{
                      getDate(device.warrantyDate)
                    }}</vs-td>
                    <vs-td
                      :data="device.hardwareAllocated"
                      v-if="device.units === 'PIECES'"
                      >{{ device && device.hardwareAllocated }}</vs-td
                    >
                    <vs-td v-else></vs-td>
                    <vs-td :data="device.propertyCode" v-if="propertyMaster">{{
                      onetimesale && onetimesale.propertyCode
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          title="UnAssign Device"
                          icon="XIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click="deallocateDevice(device)"
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vs-popup>
      </div>
      <!-- Create adjustment -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          class="popup-close"
          :title="$t('customers.label.create_adjustment')"
          :active.sync="oneTimeSalesPopup"
        >
          <vs-table :data="oneTimeSalesData">
            <template slot="header"></template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.ItemCode") }}</vs-th>
              <vs-th>{{ $t("customers.label.serial_no") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(sales, index) in data">
                <vs-td :data="sales.itemCode">{{
                  sales && sales.itemCode
                }}</vs-td>
                <vs-td :data="sales.serialNo">{{
                  sales && sales.serialNo
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-popup>
      </div>
      <!-- Create Order -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          class="popup-close"
          :title="$t('customers.label.create_order')"
          :active.sync="clientPlanPopup"
        >
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col sm:w-full w-full">
                <small class="font-semibold">{{
                  $t("customers.label.start_date")
                }}</small>
                <datepicker
                  :placeholder="$t('customers.label.SelectDate')"
                  v-model="clientPlan"
                  class="mb-2 font-semibold"
                />
              </div>
              <div class="vx-col sm:w-full w-full">
                <small class="font-semibold">{{
                  $t("customers.label.sale_catalog")
                }}</small>
                <v-select
                  label="name"
                  :options="salePlanCategory.allPlanDatas || []"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(name) => name.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
              <div class="vx-col sm:w-full w-full">
                <small class="font-semibold">{{
                  $t("customers.label.plan")
                }}</small>
                <v-select
                  label="name"
                  :options="plan"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(name) => name.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
              </div>
              <div class="vx-col sm:w-full w-full">
                <vs-checkbox class="mt-3 font-semibold">{{
                  $t("customers.label.auto_renew")
                }}</vs-checkbox>
              </div>
            </div>
            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button
                  icon-pack="feather"
                  type="border"
                  icon="icon-x"
                  @click="clientPlanPopup = false"
                  >{{ $t("customers.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-2">
                <vs-button icon-pack="feather" icon="icon-search">{{
                  $t("customers.label.search")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <!-- Service Detail-->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.client_service_detail')"
          :active.sync="clientServiceDetailPopup"
          class="popup-close popup-width"
        >
          <div class="w-full">
            <div class="block overflow-x-auto">
              <table class="table w-full table-bordered table-striped">
                <tr>
                  <td>
                    <b>{{ $t("customers.label.id") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.parameter_name") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.parameter_value") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.status") }}</b>
                  </td>
                </tr>
                <tr
                  v-for="(Broadcaster, index) in clientDetailList"
                  :key="index"
                >
                  <td>{{ Broadcaster && Broadcaster.id }}</td>
                  <td>{{ Broadcaster && Broadcaster.paramName }}</td>
                  <td>{{ Broadcaster && Broadcaster.type }}</td>
                  <td>{{ Broadcaster && Broadcaster.status }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="w-full">
            <div class="block overflow-x-auto">
              <table class="table w-full table-bordered table-striped">
                <tr>
                  <td>
                    <b>{{ $t("customers.label.provisioning_detail") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.request_type") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.status") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.task_id") }}</b>
                  </td>
                  <td>
                    <b>{{ $t("customers.label.sent_message") }}</b>
                  </td>
                </tr>
                <tr
                  v-for="(Broadcaster, index) in provisioningList"
                  :key="index"
                >
                  <td>{{ Broadcaster && Broadcaster.id }}</td>
                  <td>{{ Broadcaster && Broadcaster.requestType }}</td>
                  <td>
                    {{
                      Broadcaster && Broadcaster.isProcessed == "Y"
                        ? "Success"
                        : "Failed"
                    }}
                  </td>
                  <td>{{ Broadcaster && Broadcaster.taskId }}</td>
                  <td>
                    <div>
                      <feather-icon
                        title="Swap"
                        icon="MailIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="ml-2"
                        @click="sendMessage(Broadcaster)"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </vs-popup>
      </div>
      <!-- Change Plan-->
      <div class="centerx">
        <vs-popup
          :button-close-hidden="true"
          classContent="popup-example"
          :title="$t('customers.label.change_plan')"
          :active.sync="changePlanPopup"
          class="popup-close popup-big"
        >
          <form>
            <div class="vx-row container mb-4">
              <div
                class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
              >
                <div class="header">
                  <div
                    class="details-header2 flex justify-between items-center"
                  >
                    <h2 class="text-white">
                      {{ $t("customers.label.change_plan") }}
                    </h2>
                  </div>
                </div>

                <div class="plans vx-card p-3">
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <!-- <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <small class="date-label"
                          >{{ $t("customers.label.plan_list")
                          }}<span class="required">*</span></small
                        >
                        <v-select
                          label="name"
                          v-model="changePlanPackId"
                          :options="planPacks"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          @input="callChangePlans"
                          :reduce="(name) => name.id"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-200 w-full"
                        />
                      </div>
                    </div> -->
                    <div class="vx-col sm:w-full md:w-1/2">
                      <div class="dropdown-with-label">
                        <small class="date-label"
                          >{{ $t("customers.label.start_date")
                          }}<span class="required">*</span></small
                        >
                        <datepicker
                          :placeholder="$t('customers.label.SelectDate')"
                          v-model="changePlan.start_date"
                          class="mb-2 font-semibold"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(pricing, index) in PlanInfo"
                    :key="index"
                    class="mb-4"
                  >
                    <PricingCard
                      :data="pricing"
                      :isAddon="true"
                      :contentData="contentData"
                      :selectedAddonProp="selectedAddon"
                      @planClicked="addonSelected"
                    />
                  </div>
                </div>
              </div>
              <div
                class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
              >
                <div class="">
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="header">
                        <div class="details-header2 flex items-center">
                          <h3 class="ml-3 text-white">
                            {{ $t("customers.label.Basket") }}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="vx-card p-2">
                    <div
                      class="card p-3"
                      v-for="(addon, index) in addonData"
                      :key="index"
                    >
                      <div class="card-header">
                        <div class="card-title">{{ addon.planName }}</div>
                        <div class="delete-icon" @click="deleteAddon(index)">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path
                              d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="price-container">
                        <span class="old-price"
                          >{{
                            addonData.length && addonData[0].currencySymbol
                              ? addonData[0].currencySymbol
                              : ""
                          }}
                          {{ addon.price }}</span
                        >
                        <span class="current-price"
                          >{{
                            addonData.length && addonData[0].currencySymbol
                              ? addonData[0].currencySymbol
                              : ""
                          }}
                          {{ Number(addon.finalPrice).toFixed(2) }}</span
                        >
                      </div>
                      <!-- <ul class="features">
                      <li class="feature-item">
                        <span class="checkmark"></span>
                        10GB EU roaming included
                      </li>
                      
                    </ul> -->
                    </div>

                    <div class="text-gray-700 font-semibold">
                      {{ $t("customers.label.TotalPrice") }}
                      {{
                        Number(
                          addonData.reduce(
                            (acc, item) => acc + item.finalPrice,
                            0
                          )
                        ).toFixed(2)
                      }}
                      <span style="color: green"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="center mb-2">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="cancelAddPlan"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1 mr-1">
                <vs-button
                  @click="changePlanFunc"
                  class="footerButton-next"
                  style="top: 0px"
                  v-show="clientDetail.billingInfo.type !== 'Prepaid'"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
                <vs-button
                  @click="handleSendLink"
                  :disabled="
                    addonData.length === 0 ||
                    !(
                      paymentStatusData &&
                      (paymentStatusData.id === undefined ||
                        paymentStatusData.status === 'expired')
                    )
                  "
                  v-show="clientDetail.billingInfo.type === 'Prepaid'"
                  v-if="
                    paymentStatusData.id === undefined ||
                    paymentStatusData.status === 'expired'
                  "
                  :loading="loading"
                >
                  {{
                    $t(
                      "customers.label.Send_Link_to_Customer_to_Complete_Payment"
                    )
                  }}
                </vs-button>
                <vs-button
                  v-else
                  v-show="clientDetail.billingInfo.type === 'Prepaid'"
                  @click="handlePaymentStatus"
                  :disabled="
                    !paymentStatusData.id ||
                    paymentStatusData.status === 'expired'
                  "
                  :loading="loading"
                >
                  {{ $t("customers.label.CheckPaymentStatus") }}
                </vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <!-- Create Ticket -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.create_ticket')"
          :active.sync="ticketPopup"
          class="popup-close"
        >
          <ValidationObserver ref="observer3">
            <form>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.priority")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.priority')"
                      :key="resetKey"
                    >
                      <v-select
                        label="value"
                        :options="ticketTemplates.priorityType"
                        :placeholder="$t('customers.label.SelectPriority')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.priority"
                        :reduce="(value) => value.value"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                    :label="$t('customers.label.ticket_date')"
                    class="w-full font-semibold starlabel"
                    readonly
                    v-model="ticket.ticketDate"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.category')"
                      :key="resetKey"
                    >
                      <v-select
                        label="mCodeValue"
                        :options="ticketTemplates.problemsDatas"
                        :placeholder="$t('customers.label.SelectCategory')"
                        :reduce="(mCodeValue) => mCodeValue.id"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.problemCode"
                        class="min-w-200 w-full mb-2"
                      >
                        <template v-slot:option="option">{{
                          option.mCodeValue
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.sub_category")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.sub_category')"
                      :key="resetKey"
                    >
                      <v-select
                        label="subCategory"
                        :options="subCategoryItem"
                        :placeholder="$t('customers.label.SelectSubCategory')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.subCategory"
                        :reduce="(subCategory) => subCategory.subCategory"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.team')"
                      :key="resetKey"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.teamCode"
                        @input="getUserByTeam"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team_user")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('customers.label.team_user')"
                      :key="resetKey"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.assignedTo"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.source")
                    }}</small>
                    <v-select
                      label="mCodeValue"
                      :options="ticketTemplates.sourceData"
                      :placeholder="$t('customers.label.SelectSource')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                      :reduce="(mCodeValue) => mCodeValue.mCodeValue"
                      v-model="ticket.sourceOfTicket"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <div class="dropdown-with-label">
                    <small class="date-label">{{
                      $t("customers.label.due_time")
                    }}</small>
                    <flat-pickr
                      :config="configdateTimePicker"
                      class="w-full"
                      v-model="ticket.dueTime"
                    />
                  </div>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.title')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('customers.label.title')"
                      v-model="ticket.title"
                      class="w-full font-semibold mb-2 starlabel"
                      icon-no-border
                      :danger="false"
                      danger-text="wrong input"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
                  <pick-file @fileUpdate="changeFile" />
                </div>
              </div>
              <div class="vx-col sm:w-full lg:w-full md:w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.description")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.description')"
                    :key="resetKey"
                  >
                    <vs-textarea class="w-full" v-model="ticket.description" />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div style="height: 30px"></div>
              <div class="center">
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addTicket"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("customers.label.submit") }}</vs-button
                  >
                </span>
              </div>
              <div style="height: 20px"></div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
      <!-- change sim -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.swap_sim')"
          :active.sync="swapPopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="dropdown-with-label mb-2">
                  <small class="date-label">
                    Current MSISDN:
                    {{
                      oldDeviceItem.mobileNo && oldDeviceItem.mobileNo.msisdn
                        ? oldDeviceItem.mobileNo.msisdn
                        : ""
                    }}
                  </small>
                </div>

                <div class="dropdown-with-label mb-2">
                  <small class="date-label"
                    >IMSI No:
                    {{
                      oldDeviceItem.mobileNo && oldDeviceItem.mobileNo.imsi
                        ? oldDeviceItem.mobileNo.imsi
                        : ""
                    }}</small
                  >
                </div>
                <div
                  class="dropdown-with-label mb-2"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;
                  "
                >
                  <small class="date-label">Status:</small>
                  <vs-chip
                    :color="
                      oldDeviceItem.status &&
                      oldDeviceItem.status.toLowerCase() === 'active'
                        ? 'success'
                        : getOrderStatusColor(oldDeviceItem.status)
                    "
                    class="product-order-status"
                  >
                    {{ oldDeviceItem.status || "" }}
                  </vs-chip>
                </div>

                <div class="search-container mb-4">
                  <vs-input
                    v-model="simSearch"
                    :label="$t('New IMSI Number')"
                    :placeholder="$t('Enter last 4 digit of sim number')"
                    class="search-input"
                  />
                </div>
                <small class="dropdown-with-label date-label"
                  >Upload ID Proof:
                </small>
                <!-- upload part is not done from backend -->
                <input
                  type="file"
                  multiple
                  @change="handleDocumentUpload"
                  class="mb-2"
                  style="max-width: 200px"
                />
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="swapDeviceFunc"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.submit") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <!-- spend Cap -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.SpendCap') + ' ' + oldCap / 10000"
          :active.sync="spendCapPopup"
          class="popup-close popup2"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-full w-full">
                <div class="amount-selector" style="justify-content: center">
                  <div
                    v-for="(amount, index) in spendCapAmounts"
                    :key="index"
                    class="amount-box"
                    :class="{
                      selected: selectedAmount === amount.value,
                    }"
                    @click="selectAmount(amount.value)"
                  >
                    {{ amount.label }}
                  </div>
                </div>
                <div class="flex justify-center mt-8">
                  <Gauge
                    :capLimit="Number(oldCap)"
                    :consumed="
                      (spendCapData.antiBillShockDet &&
                        spendCapData.antiBillShockDet[0].consumedLimit) ||
                      0
                    "
                  />
                </div>
              </div>
            </div>
            <div class="h-10"></div>
            <div class="center">
              <span class="ml-1 mr-1 mt-12">
                <vs-button
                  @click="updateSpendCap"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.save") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <!--On Demand Biling-->
      <div class="centerx">
        <vs-popup
          classContent="popup-example popup3"
          :title="$t('customers.label.on_demand_billing')"
          :active.sync="orderChargingPopup"
          class="popup-close popup2"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.process_date")
                    }}<span class="required">*</span></small
                  >
                  <datepicker
                    :placeholder="$t('customers.label.select_date')"
                    v-model="orderCharging.systemDate"
                    class="mb-5 font-semibold"
                  />
                </div>
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1 mt-4">
                <vs-button
                  @click="orderChargeFunc"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <!--Deposit -->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.deposit')"
          :active.sync="depositPopup"
          class="popup-close small-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.Amount")
                    }}<span class="required">*</span></small
                  >
                  <v-select
                    label="defaultFeeAmount"
                    v-model="deposits"
                    :options="editDepositTemplate"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(defaultFeeAmount) => defaultFeeAmount.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                    <template v-slot:option="option">{{
                      option.defaultFeeAmount
                    }}</template>
                  </v-select>
                </div>
              </div>
            </div>
            {{ errorMessage }}
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="depositFunc"
                  :disabled="!deposits"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <!-- Balance Transfer  -->
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('customers.label.BalanceTransfer')"
          :active.sync="recieverPopup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.RecieverClientId')"
                  class="w-full starlabel mb-2 font-semibold"
                  v-model="reciverId"
                  v-on:keyup.enter="enterCapture"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <vs-input
                  :label="$t('customers.label.Amount')"
                  class="w-full starlabel mb-2 font-semibold"
                  v-model="deposits"
                />
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <div class="shadow-md p-2">
                  <div class="header">
                    <div
                      class="details-header flex justify-between items-center"
                    >
                      <div>
                        {{ $t("customers.label.contact_information") }}
                      </div>
                    </div>
                  </div>
                  <div class="p-2">
                    <div class="grid grid-cols-[1fr,2fr] gap-1">
                      <h6 class="font-semibold">
                        {{ $t("customers.label.customer_name") }}:
                      </h6>
                      <span
                        >{{
                          clientDetail &&
                          clientDetail.personalInfo &&
                          clientDetail.personalInfo.firstName
                        }}
                        {{
                          clientDetail &&
                          clientDetail.personalInfo &&
                          clientDetail.personalInfo.middleName
                        }}
                        {{
                          clientDetail &&
                          clientDetail.personalInfo &&
                          clientDetail.personalInfo.lastName
                        }}</span
                      >
                      <h6 class="font-semibold">
                        {{ $t("customers.label.parent_child") }}:
                      </h6>
                      <span>{{
                        clientDetail &&
                        clientDetail.accountInfo &&
                        clientDetail.accountInfo.parentInfo
                      }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.preferred_language") }}:
                      </h6>
                      <span>{{ "" }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.email") }}:
                      </h6>
                      <span>{{
                        clientDetail &&
                        clientDetail.personalInfo &&
                        clientDetail.personalInfo.email
                      }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.phone") }}:
                      </h6>
                      <span>{{
                        clientDetail &&
                        clientDetail.personalInfo &&
                        clientDetail.personalInfo.mobileNumber
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-4">
                <div class="shadow-md p-2" v-if="reciverId">
                  <div class="header">
                    <div
                      class="details-header flex justify-between items-center"
                    >
                      <div>
                        {{ $t("customers.label.address_information") }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="p-2 card-content"
                    v-for="(item, k) in clientDetail.addresses"
                    :key="k"
                  >
                    <div
                      class="grid grid-cols-2 gap-2"
                      v-if="item.type == 'PRIMARY'"
                    >
                      <h6 class="font-semibold">
                        {{ $t("customers.label.address") }}:
                      </h6>
                      <span>{{ item.addressNo }}{{ item.street }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.district") }}:
                      </h6>
                      <span>{{ item.district }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.city") }}:
                      </h6>
                      <span>{{ item.city }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.pincode") }}:
                      </h6>
                      <span>{{ item.zip }}</span>
                      <h6 class="font-semibold">
                        {{ $t("customers.label.state") }}:
                      </h6>
                      <span>{{ item.state }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="recieverFunc"
                  class="footerButton-next"
                  style="top: 20px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <!--top up-->
      <div class="centerx">
        <vs-popup
          class="popup-close small-popup"
          :title="$t('customers.label.top_up')"
          :active.sync="openTopUp"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-full w-full">
                <vs-input
                  :label="$t('customers.label.EnterTopUpAmount')"
                  class="w-full starlabel mb-2 font-semibold"
                  v-model="topupAmount"
                  @input="selectAmount"
                />
              </div>
              <div class="vx-col md:w-full w-full">
                <div class="amount-selector">
                  <div
                    v-for="(amount, index) in amounts"
                    :key="index"
                    class="amount-box"
                    :class="{
                      selected: selectedAmount === amount,
                    }"
                    @click="selectAmount(amount)"
                  >
                    {{ amount }}
                  </div>
                </div>
              </div>
              <!-- <div class="vx-col sm:w-full w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="topup comment"
                >
                  <vs-input
                    :label="$t('system.label.comment')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="topupComment"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div> -->
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  class="footerButton-next"
                  style="top: 20px"
                  :disabled="!topupAmount"
                  @click="handleTopupContinue"
                  >{{ $t("customers.label.continue") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <!--renewal-->
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('customers.label.renewal')"
          :active.sync="openRenewal"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-full w-full">
                <dl class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-3">
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.PlanCode") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ planItemData[0] && planItemData[0].planCode }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.Price") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      ${{ planItemData[0] && planItemData[0].price }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.Status") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ planItemData[0] && planItemData[0].status }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.StartDate") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{
                        formatDate(planItemData[0] && planItemData[0].startDate)
                      }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.EndDate") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ calculateEndDate }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.ContractPeriod") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ planItemData[0] && planItemData[0].contractPeriod }}
                    </dd>
                  </div>
                  <div class="sm:col-span-1">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.AutoRenew") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{
                        planItemData[0] && planItemData[0].autoRenew === "Y"
                          ? "Yes"
                          : "No"
                      }}
                    </dd>
                  </div>
                  <div class="sm:col-span-2">
                    <dt class="text-sm font-medium text-gray-500">
                      {{ $t("customers.label.Description") }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ planItemData[0] && planItemData[0].planDescription }}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="renewalFunc1(planItemData[0])"
                  class="footerButton-next"
                  style="top: 10px"
                  >{{ $t("customers.label.renew_plan") }}</vs-button
                >
              </span>
            </div>
          </form>
        </vs-popup>
      </div>
      <!--Redeem-->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.redeem')"
          :active.sync="redeemPopup"
          class="popup-close small-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full mb-6">
                <vs-input
                  :label="$t('customers.label.pin_number')"
                  v-model="redeem.pinNumber"
                  class="w-full font-semibold mb-2 starlabel"
                  icon-no-border
                  :danger="false"
                  danger-text="wrong input"
                />
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="redeemFunc"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
      <!--Renewal-->
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('customers.label.renewal')"
          :active.sync="renewalPlanPopup"
          class="popup-close mid-popup"
        >
          <form>
            <div class="vx-row">
              <div class="vx-col w-full mb-6">
                <small class="date-label">{{
                  $t("customers.label.description")
                }}</small>
                <vs-textarea v-model="renewalDescription" />
              </div>
            </div>
            <div class="error">
              {{ errorMessage }}
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="renewalFunc"
                  class="footerButton-next"
                  style="top: 0px"
                  >{{ $t("customers.label.confirm") }}</vs-button
                >
              </span>
            </div>
            <div style="height: 20px"></div>
          </form>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Information from "./Information.vue";
import ServiceOverview from "./ServiceOverview/Index.vue";
import PricingCard from "./../customerActivation/PlanInfoCardConponent.vue";
import MoreInfo from "./more-info/Index";
import Ticket from "./ticket/Index";
import OnDemand from "./ondemand/Index";
import Accounts from "./accounts/Index";
import Payments from "./payments/Index";
import Adjastment from "./adjastment/Index";
import Statement from "./statement/Index";
import BillProfile from "./clientbillprofile/ViewBillProfile";
import CollectionAction from "./CollectionAction.vue";
import ActivityLog from "./activitylog/ActivityLog";
import Child from "./childs/Index";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import Gauge from "@/components/Gauge.vue";
import "flatpickr/dist/flatpickr.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import vSelect from "vue-select";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import { setHeader, removeHeader } from "@/http";
import PickFile from "@/components/PickFile.vue";
import _ from "lodash";
import { AtomSpinner } from "epic-spinners";

const planChangeEmpty = {
  billAlign: false,
  planId: "",
  Newplanprepaid: "",
  clientServiceId: "",
  clientId: "",
  isNewplan: false,
  oldplanId: "",
  oldplanprepaid: "",
  locale: "en",
  dateFormat: "yyyy-MM-dd HH:mm:ss",
  start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
  contractPeriodId: "",
  paytermCode: "",
  planPoId: "",
  dealPoId: "",
  changePlanDetail: "",
  disconnectionDate: moment().format("YYYY-MM-DD HH:mm:ss"),
  disconnectReason: "Not Interested",
};
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};
const swapObj = {
  oldSerialNo: "",
  type: "",
  clientId: "",
  itemId: "",
  newSerialNo: "",
  orderId: "",
  saleType: "NEWSALE",
  clientServiceId: "",
  oldPSerialNo: "",
  newPSerialNo: "",
  remark: "",
  isGenerateProvisionReq: true,
  isPairable: false,
  pairableItemDetails: [],
};
const itemDetailEmpty = {
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  officeId: 0,
  itemId: 0,
  chargeCode: "",
  unitPrice: 0,
  quantity: "1",
  discountId: 1,
  totalPrice: 0,
  saleType: "NEWSALE",
  saleDate: moment().format("DD MMMM YYYY"),
  serialNumber: [],
  isPairing: "N",
};
const planDataEmpty = {
  billAlign: false,
  autoRenew: "",
  planCode: "",
  contractPeriod: "",
  paytermCode: "",
  isNewplan: true,
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  start_date: moment().format("DD MMMM YYYY"),
};
const serialNoEmpty = {
  serialNumber: "",
  status: "allocated",
  saleType: "NEWSALE",
  itemMasterId: "",
  isNewHw: "Y",
  itemType: "",
};
export default {
  data() {
    return {
      simSearch: "",
      showUploadDocuments: false,
      uploadedDocuments: [],
      externalSimInfo: null,
      searchSwapSerialNumberInfo: null,
      selectedAmount: 10,
      addonData: [],
      contentData: [],
      selectedAddon: "",
      oldCap: "",
      amounts: [5, 10, 20, 30, 50],
      spendCapAmounts: [
        { value: 2500000, label: "250" },
        { value: 5000000, label: "500" },
        { value: 10000000, label: "1000" },
        { value: 20000000, label: "2000" },
      ],
      topupAmount: 10,
      topupComment: "",
      openTopUp: false,
      openRenewal: false,
      deposits: "",
      loading: false,
      reciverId: "",
      orderDetails: {},
      deviceOverviewPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      datetime: null,
      serviceOrderToggle: true,
      clientBillProfileToggle: false,
      moreInfoToggle: false,
      billCollectionToggle: false,
      transactionToggle: false,
      DemandToggle: false,
      AccountsToggle: false,
      PaymentsToggle: false,
      StatementsToggle: false,
      ChildsToggle: false,
      ActivityToggle: false,
      oneTimeSalesPopup: false,
      clientPlanPopup: false,
      oneTimeSalesData: [],
      addService: "",
      plan: [],
      planList: "",
      selectedService: [],
      propertyMaster: false,
      clientId: null,
      serviceInfo: {},
      serviceInfoPopup: false,
      clientPlan: "",
      salePlanCategory: {},
      file: null,
      clientServiceDetailPopup: false,
      clientServiceId: "",
      changePlanPopup: false,
      changePlanPayload: {
        billAlign: true,
        autoRenew: false,
      },
      changePlan: { ...planChangeEmpty },
      changePlanPackId: "",
      currentPlanId: "",
      currentPlanOrderId: "",
      selectedChangePlan: {},
      loc: "",
      serialitemdetail: [],
      activation: {
        loc: "",
        email: "",
        fullName: "",
        address: "",
        idProof: "",
        village: "",
        phone: "",
        CafId: "",
        idProofValue: "",
        city: "",
        addService: "",
        networkNode: "",
        serialNo: "",
        pairSerialNo: "",
        planlist: "",
        plan: "",
        serviceId: "",
        unitPrice: "",
        itemType: "",
        activationDate: moment().format("DD MMMM YYYY"),
      },
      pairableItemDetails: {
        ...itemDetailEmpty,
      },
      planData: [{ ...planDataEmpty }],
      serialNumObjPaired: {
        ...serialNoEmpty,
      },
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null,
      },
      ticketPopup: false,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      swapPopup: false,
      deviceSwap: { ...swapObj },
      oldDeviceItem: {},
      orderCharging: {
        locale: "en",
        dateFormat: "yyyy-MM-dd HH:mm:ss",
        systemDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      orderChargingPopup: false,
      depositPopup: false,
      spendCapPopup: false,
      recieverPopup: false,
      redeem: {
        clientId: "",
        pinNumber: "",
        MSISDN: "",
        officeId: "",
      },
      redeemPopup: false,
      renewalDescription: "",
      renewalPlanPopup: false,
      currentPriceId: 0,
      currentPlan: {},
    };
  },
  components: {
    Information,
    ServiceOverview,
    CollectionAction,
    VueSimpleSuggest,
    PricingCard,
    BillProfile,
    MoreInfo,
    Ticket,
    OnDemand,
    Accounts,
    Payments,
    Adjastment,
    ActivityLog,
    Statement,
    Child,
    flatPickr,
    Datepicker,
    "v-select": vSelect,
    PickFile,
    ValidationProvider,
    ValidationObserver,
    AtomSpinner,
    Gauge,
  },
  computed: {
    ...mapState({
      profilePic: (state) => state.customer.profilePic,
      itemList: (state) => state.customer.itemList,
      PlanInfo: (state) => state.customerActivationNew.planData,
      paymentStatusData: (state) =>
        state.customerActivationNew.paymentStatusData,
      itemDetail: (state) => state.customerActivation.itemDetail,
      planPacks: (state) => state.customer.planPacks,
      clientDetailList: (state) => state.customer.clientDetails,
      provisioningList: (state) => state.customer.provisioningList,
      saleTemplateList: (state) => state.customerActivation.saleTemplateList,
      clientDetail: (state) => state.customer.clientDetailData,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      teamUsers: (state) => state.customer.teamUsers,
      swapTemplate: (state) => state.customer.swapTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
      oneTimeSalesList: (state) => state.customer.oneTimeSales,
      editDepositTemplate: (state) => state.customer.editDepositTemplate,
      spendCapData: (state) => state.customer.spendCapData,
    }),
    calculateEndDate() {
      const startDate = moment(
        this.formatDate(this.planItemData && this.planItemData.startDate)
      );
      const contractPeriod =
        this.planItemData && this.planItemData.contractPeriod;
      let endDate;
      if (contractPeriod && contractPeriod.includes("Month")) {
        const months = parseInt(contractPeriod);
        endDate = startDate.clone().add(months, "months");
      } else if (contractPeriod && contractPeriod.includes("Year")) {
        const years = parseInt(contractPeriod);
        endDate = startDate.clone().add(years, "years");
      } else {
        // Default to 1 month if contract period is not recognized
        endDate = startDate.clone().add(1, "month");
      }
      return endDate.format("DD-MMMM-YYYY");
    },
    uniqueItems() {
      const uniqueCodes = {};
      return (
        this.clientDetail &&
        this.clientDetail.services.flatMap((service) =>
          service.devices.filter((device) => {
            if (!uniqueCodes[device.itemCode]) {
              uniqueCodes[device.itemCode] = true;
              return true;
            }
            return false;
          })
        )
      );
    },
    planItemData() {
      return this.clientDetail.services.flatMap((service) =>
        service.plans.map((x) => {
          return x;
        })
      );
    },
    ticketTemplates() {
      return this.$store.getters["entity/getTicketTemplate"];
    },
    deviceOverView() {
      const serviceIds = _.uniq(_.map(this.selectedService, "id"));
      return _.filter(
        this.clientDetail &&
          this.clientDetail.services
            .map((service) => service.devices)
            .flat()
            .filter((item) => {
              return _.indexOf(serviceIds, item.clientServiceId) >= 0;
            })
      );
    },
    profileBgCol() {
      if (
        this.clientDetail &&
        this.clientDetail.billingInfo &&
        this.clientDetail.billingInfo.type === "Postpaid"
      ) {
        return "#b7ffe0";
      }
      return "#b7ecff";
    },
    categoryColor() {
      if (
        this.clientDetail &&
        this.clientDetail.billingInfo &&
        this.clientDetail.billingInfo.type === "Postpaid"
      ) {
        return "#00a031";
      }
      return "#0077a0";
    },
  },
  methods: {
    async searchSwapSerialNumber() {
      if (this.simSearch.length === 4) {
        try {
          const res = await this.$store.dispatch(
            "customer/getSwapSerialNumberAction",
            this.simSearch
          );
          this.searchSwapSerialNumberInfo = res.data;
          if (res.status === 200) {
            if (res.data.Response.message === "No record found") {
              this.$swal({
                title: "Error",
                icon: "error",
                text: res.data.Response.message,
                type: "error",
              });
            } else if (
              res.data.Response.message === "Get All Sim details Success"
            ) {
              this.$swal({
                title: "Success",
                icon: "success",
                text: res.data.Response.message,
                type: "success",
              });
            }
          }
        } catch (e) {
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Failed to search SIM number.",
            type: "error",
          });
        }
      }
    },
    getOrderStatusColor(status) {
      if (status === "Inactive") return "dark";
      if (status === "New") return "warning";
      if (status === "DRAFT") return "danger";
      if (status === "TERMINATED") return "danger";
      if (status === "DISCONNECTED") return "danger";
      if (status === "SUSPENDED") return "dark";
      if (status === "Pending") return "orange";
      if (status === "PROCESSING") return "orange";
      return "success";
    },
    handleDocumentUpload(event) {
      this.uploadedDocuments = Array.from(event.target.files);
    },
    addonSelected(plan, data, content, p, sel) {
      this.selectedAddon = sel;

      const planData = {
        ...content,
        ...plan,
        planName: data.planCode,
        currencySymbol: data.symbol,
      };
      this.addonData = [planData];
      this.selectedChangePlan = this.saleTemplateList.filter(
        (item) => item.id === data.id
      )[0];
    },
    cancelAddPlan() {
      this.changePlanPopup = false;
      // this.planObj = {
      //   planId: "",
      //   selectedPlans: [],
      //   startDate: moment().format("DD MMMM YYYY"),
      // };
      (this.selectedChangePlan = ""), (this.selectedAddon = "");
      this.addonData = [];
      this.getPlanInfoMethod("");
    },
    deleteAddon(index) {
      this.addonData.splice(index, 1);
      this.selectedAddon = "";
    },
    async handleSendLink() {
      let payload = {
        amount: {
          currency: this.clientDetail.billingInfo.currencyCode,
          value: Math.round(
            this.addonData.reduce((acc, item) => acc + item.finalPrice, 0) * 100
          ),
        },
        description: "Test",
        countryCode: "GB",
        shopperLocale: "en-GB",
        email: this.clientDetail.personalInfo.email,
        pkgName: this.addonData[0].planName,
        subsName: this.clientDetail.personalInfo.displayName,
      };
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/sendLinkAction",
          payload
        );
        this.changePlanPopup = false;
        await this.$swal({
          title: "info",
          icon: "info",
          text: "Payment Link Successfully Sent.",
          type: "info",
        });
        this.changePlanPopup = true;
      } catch (error) {
        this.$swal({
          title: "error",
          icon: "error",
          text: "Not able to send payment link! Try again later.",
          type: "error",
        });
      }
      this.loading = false;
    },
    async getPlanInfoMethod(type) {
      const data = {
        locale: "en",
        plantype: type,
        isprepaid: this.clientDetail.billingInfo.type === "Prepaid" ? "Y" : "N",
        salesChannel: "POS",
        accessibleOnly: "Y",
      };

      const processedIds = new Set();
      try {
        await this.$store
          .dispatch("customerActivationNew/fetchPlanInfoAction", data)
          .then((res) => {
            const pageItems = res.data.pageItems;
            for (const x of pageItems) {
              if (processedIds.has(x.id)) continue;
              processedIds.add(x.id);
              pageItems.forEach((item) => {
                this.contentData.push(item.documentData);
              });
            }
          });
      } catch (error) {
        throw Error();
        //
      }
    },
    async handlePaymentStatus() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "customerActivationNew/checkPaymentStatus",
          this.paymentStatusData.id
        );
        this.loading = false;
        if (this.paymentStatusData.status === "completed") {
          // this.$swal({
          //   title: "Success",
          //   icon: "success",
          //   text: "Payment Successful!",
          //   type: "success",
          // });
          const payload = {
            paymentCode: 728,
            amountPaid: (this.paymentStatusData.amount.value / 100)
              .toFixed(2)
              .toString(),
            receiptNo: this.paymentStatusData.reference,
            remarks: "Online Payment",
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            paymentDate: moment().format("DD MMMM YYYY"),
            isSubscriptionPayment: false,
          };
          await this.$store.dispatch("customerActivation/afterPayments", {
            id: this.$route.params.id,
            data: payload,
          });
          this.addPlanFunc();
        } else if (this.paymentStatusData.status === "active") {
          this.changePlanPopup = false;
          await this.$swal({
            title: "info",
            icon: "info",
            text: "Payment is pending!",
            type: "info",
          });
          this.changePlanPopup = true;
        } else if (this.paymentStatusData.status === "expired")
          this.changePlanPopup = false;
        await this.$swal({
          title: "Expired",
          icon: "warning",
          text: "Payment Link Expired! Try Again.",
          type: "warning",
        });
        this.$store.dispatch("customerActivationNew/clearPaymentData");
        this.changePlanPopup = true;
      } catch (error) {
        console.log(error, "error");
      }
    },
    //  async addPlanFunc() {
    //   let payload = { plans: [] };
    //   for (let temp of this.planObj.selectedPlans) {
    //     let planData = {
    //       planId: temp.id,
    //       paytermCode: temp.chargeCycle,
    //       contractPeriodId: temp.contractPeriodId || null,
    //       clientServiceId: this.clientDetail.services[0].id || "",
    //       billAlign: true,
    //       clientId: this.$route.params.id,
    //       locale: "en",
    //       dateFormat: "dd MMMM yyyy",
    //       start_date: this.planObj.startDate,
    //       isNewplan: true,
    //       channel: this.clientDetail.services[0].salesMotion || "POS",
    //     };
    //     payload.plans.push(planData);
    //   }
    //   try {
    //     await this.$store.dispatch("customer/addPlanCatalogueAction", {
    //       id: this.$route.params.id,
    //       data: payload,
    //     });
    //     this.$store.dispatch("customerActivationNew/clearPaymentData");
    //     this.changePlanPopup = false;
    //     this.selectedAddon = "";
    //     this.planObj = {
    //       planId: "",
    //       selectedPlans: [],
    //       startDate: moment().format("DD MMMM YYYY"),
    //     };
    //     this.addonData = [];
    //     this.getPlanInfoMethod("");
    //     this.$swal({
    //       title: "Success",
    //       icon: "success",
    //       text: "Plan Added Successfully!",
    //       type: "success",
    //     });
    //     this.getClient();
    //   } catch (e) {
    //     this.warningText = "";
    //     this.errorMessage = e.message.replace("The parameter", "");
    //     this.warningPopup = true;
    //     this.errors = e.message.errors;
    //   }
    // },
    async callCustomer(phone) {
      try {
        const agent = JSON.parse(sessionStorage.getItem("ngb:user"));
        const payload = {
          callerId: phone,
          userId: agent.userId || 8,
        };
        await this.$store.dispatch("customer/callCustomerAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong",
          type: "error",
        });
      }
    },
    formatDate(dateArray) {
      const [year, month, day] = Array.isArray(dateArray)
        ? dateArray
        : [0, 0, 0];
      return `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;
    },
    renewPlan() {
      alert("Plan renewal initiated!");
    },
    selectAmount(amount) {
      this.selectedAmount = amount;
      this.topupAmount = this.selectedAmount;
    },
    async handleTopupContinue() {
      let payload = {
        amount: this.topupAmount,
        msisdn: this.clientDetail.hwSerialNumber,
        receiptNo: `R${Date.now()}${Math.floor(Math.random() * 1000)}`,
      };
      try {
        const response = await this.$store.dispatch(
          "customer/getTopupAction",
          payload
        );
        console.log(response, "RESP");
        if (response.status === 200) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Topup Successful!",
            type: "success",
          });
        }
      } catch (e) {
        this.warningPopup = true;
        this.warningText = "Something went wrong! Try Later.";
      } finally {
        this.openTopUp = false;
      }
    },
    openChangePlan(service, order, planType) {
      this.resetChangePlanForm();
      if (planType == "BasePlan") this.changePlanPackId = 1;
      else this.changePlanPackId = 2;
      this.$store.dispatch(
        "customerActivation/getSalesTemplateList",
        this.changePlanPackId
      );
      this.changePlanPopup = true;
      this.getPlanInfoMethod(planType);
      this.clientServiceId = service;
      this.currentPlanOrderId = order[0].orderId;
      this.currentPlanId = order[0].planId;
      this.orderDetails = order[0];
    },
    togglePage(val) {
      this.serviceOrderToggle = false;
      this.clientBillProfileToggle = false;
      this.billCollectionToggle = false;
      this.moreInfoToggle = false;
      this.transactionToggle = false;
      this.DemandToggle = false;
      this.AccountsToggle = false;
      this.PaymentsToggle = false;
      // this.AdjastmentToggle = false;
      this.StatementsToggle = false;
      this.ChildsToggle = false;
      this.ActivityToggle = false;
      switch (val) {
        case 1: {
          this.serviceOrderToggle = true;
          break;
        }
        case 2: {
          this.moreInfoToggle = true;
          break;
        }
        case 13: {
          this.clientBillProfileToggle = true;
          break;
        }
        case 14: {
          this.billCollectionToggle = true;
          break;
        }
        case 5: {
          this.transactionToggle = true;
          break;
        }
        case 6: {
          this.DemandToggle = true;
          break;
        }
        case 7: {
          this.AccountsToggle = true;
          break;
        }
        case 8: {
          this.PaymentsToggle = true;
          break;
        }
        // case 9: {
        //   this.AdjastmentToggle = true;
        //   break;
        // }
        case 12: {
          this.StatementsToggle = true;
          break;
        }
        case 11: {
          this.ChildsToggle = true;
          break;
        }
        case 10: {
          this.ActivityToggle = true;
          break;
        }
      }
    },
    async showSpendCap(val, id) {
      await this.$store.dispatch(
        "customer/getSpendCapAction",
        "91" + this.getProvisionalNumber("MSISDN")
      );
      this.spendCapPopup = true;
      this.oldCap = parseInt(val);
      this.selectedAmount = parseInt(val);
      this.clientServiceId = id;
      if (
        this.spendCapData.antiBillShockDet &&
        this.spendCapData.antiBillShockDet[0].spendingLimit &&
        this.spendCapData.antiBillShockDet &&
        this.spendCapData.antiBillShockDet[0].spendingLimit !== parseInt(val)
      ) {
        this.selectedAmount =
          this.spendCapData.antiBillShockDet &&
          this.spendCapData.antiBillShockDet[0].spendingLimit;
        this.updateSpendCapInti();
      }
      this.spendCapData.antiBillShockDet[0].spendingLimit = 0;
    },
    getProvisionalNumber(itemCode) {
      const item = this.clientDetail.services[0].devices.find(
        (item) => item.itemCode === itemCode
      );
      return item ? item.provserialnumber : "";
    },
    getDate(date) {
      if (typeof date == "object") {
        const dateFormat = new Date(date[0], date[1] - 1, date[2]);
        date = dateFormat.toLocaleDateString("en-US");
      }
      return moment(date).format(this.formattedDate);
    },
    async getClient() {
      try {
        await this.$store.dispatch(
          "customer/setClientDetailData",
          this.$route.params.id
        );
        this.loc = this.clientDetail.accountInfo.office.id;
        const service = this.clientDetail.services[0];
    if (service && service.status && service.status.toUpperCase() === "ACTIVE") {
      const payload = {
        customerId: this.clientDetail.externalId,
        accountNo: service.serviceAccountNo,
        serviceNumber: this.getProvisionalNumber("MSISDN"),
        type: this.clientDetail.billingInfo.type.toLowerCase(),
      };
      this.$store.dispatch("customerOrder/fetchAllowance", payload);
    };
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text:
            error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage,
          type: "error",
        });
      }
    },
    async enterCapture() {
      const receiverClientId = this.reciverId.replace(/[^0-9]*0*(\d+)/, "$1");
      try {
        await this.$store.dispatch(
          "customer/setClientDetailData",
          receiverClientId
        );
      } catch (error) {
        throw Error(
          (error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage) ||
            `Api failed with status code: ${
              error && error.message && error.message.httpStatusCode
            }`
        );
      }
    },
    async getProfilePic() {
      try {
        await this.$store.dispatch(
          "customer/getClientProfilePic",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          (error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage) ||
            `Api failed with status code: ${
              error && error.message && error.message.httpStatusCode
            }`
        );
      }
    },
    oneTimeSales(serviceNo) {
      if (serviceNo) {
        this.oneTimeSalesPopup = true;
        this.getOneTimeSales(serviceNo);
      }
    },
    async getOneTimeSales(serialNo) {
      try {
        await this.$store.dispatch("customer/getOneTimeSalesAction", serialNo);
        this.oneTimeSalesData = this.oneTimeSalesList;
      } catch (error) {
        throw Error(
          (error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage) ||
            `Api failed with status code: ${
              error && error.message && error.message.httpStatusCode
            }`
        );
      }
    },
    async deallocateDevice(device) {
      try {
        const data = {
          clientId: this.$route.params.id,
          clientServiceStatus: device.clientServiceStatus,
          isStraight: true,
          serialNo: device.serialNo,
        };
        const payload = {
          id: device.id,
          data: data,
        };
        await this.$store.dispatch(
          "customer/deallocateClientDeviceAction",
          payload
        );
      } catch (e) {
        this.errorMessage =
          e.message.userMessageGlobalisationCode.toUpperCase();
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getPlanPacks() {
      await this.$store.dispatch("customer/getPlanPackAction");
    },
    getPercent() {
      if (!this.spendCapData.antiBillShockDet) return 100;
      const usage = this.spendCapData.antiBillShockDet[0].consumedLimit;
      const percent = (usage / this.oldCap) * 100;
      return percent;
    },
    async callChangePlans() {
      if (this.changePlanPackId === 1) {
        this.getPlanInfoMethod("BasePlan");
      }
      if (this.changePlanPackId === 2) {
        this.getPlanInfoMethod("AddonPlan");
      }

      try {
        await this.$store.dispatch(
          "customerActivation/getSalesTemplateList",
          this.changePlanPackId
        );
      } catch (error) {
        throw Error(
          (error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage) ||
            `Api failed with status code: ${
              error && error.message && error.message.httpStatusCode
            }`
        );
      }
    },
    async changePlanFunc() {
      this.changePlan.planId = this.selectedChangePlan.id;
      this.changePlan.contractPeriodId =
        this.selectedChangePlan.contractPeriodId;
      this.changePlan.Newplanprepaid =
        this.selectedChangePlan &&
        this.selectedChangePlan.availableServices[0] &&
        this.selectedChangePlan.availableServices[0].isPrepaid;
      this.changePlan.clientServiceId = this.clientServiceId;
      this.changePlan.clientId = this.$route.params.id;
      this.changePlan.oldplanId = this.currentPlanId;
      this.changePlan.changePlanDetail = `${this.currentPlanOrderId} changed to ${this.selectedChangePlan.planCode}`;
      this.changePlan.paytermCode =
        this.selectedChangePlan && this.selectedChangePlan.chargeCycle;
      this.changePlan.planPoId =
        (this.selectedChangePlan && this.selectedChangePlan.planPoId) || 0;
      this.changePlan.dealPoId =
        (this.selectedChangePlan && this.selectedChangePlan.dealPoId) || 0;
      this.changePlan.start_date = moment(this.changePlan.start_date).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.changePlan.oldplanprepaid =
        this.orderDetails.isPrepaid === "Y" ? "Y" : "N";
      try {
        await this.$store.dispatch("customer/changePlanAction", {
          id: this.currentPlanOrderId,
          data: this.changePlan,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Plan Replaced Successfully!",
          type: "success",
        });
      } catch (e) {
        this.warningPopup = true;
        this.warningText = "Something went wrong!";
      } finally {
        this.changePlanPopup = false;
      }
    },
    resetChangePlanForm() {
      Object.assign(this.changePlan, this.planChangeEmpty);
      this.changePlanPackId = null;
      this.selectedChangePlan = null;
      this.changePlan.autoRenew = false;
      this.currentPlanId = "";
      this.currentPlanOrderId = "";
    },
    renewalPlan(serviceId, order) {
      this.renewalPlanPopup = true;
      this.clientServiceId = serviceId;
      this.currentPlan = order;
      this.getPriceDetail(order.orderId);
    },
    swapDevice(serviceId, device) {
      this.swapPopup = true;
      this.oldDeviceItem = device;
      this.clientServiceId = serviceId;
    },
    async addTicket() {
      const isValid = await this.$refs.observer3.validate();
      if (!isValid) return;
      try {
        if (this.ticketURL2)
          this.ticket.ticketURL = `${this.ticket.ticketURL2}${this.$route.params.id}`;
        this.ticket.ticketTime = " " + this.ticket.ticketTime;
        delete this.ticket.ticketURL2;
        this.ticket.teamUserId = this.ticket.assignedTo;
        delete this.ticket.dueTime;
        let formData = new FormData();
        setHeader("Content-Type", "multipart/form-data");
        formData.append("teamCode", this.ticket.teamCode);
        formData.append("name", this.ticket.title);
        formData.append("description", this.ticket.description);
        formData.append("file", this.bulkUploads.file);
        formData.append("teamUserId", this.ticket.teamUserId);
        formData.append("assignedTo", this.ticket.assignedTo);
        formData.append("dateFormat", this.ticket.dateFormat);
        formData.append("locale", this.ticket.locale);
        formData.append("priority", this.ticket.priority);
        formData.append("problemCode", this.ticket.problemCode);
        formData.append("sourceOfTicket", this.ticket.sourceOfTicket);
        formData.append("ticketDate", this.ticket.ticketDate);
        formData.append("ticketTime", this.ticket.ticketTime);
        formData.append("subCategory", this.ticket.subCategory);
        formData.append("ticketURL", this.ticket.ticketURL);
        formData.append("type", this.ticket.type);
        formData.append("title", this.ticket.title);
        removeHeader("Content-Type");
        await this.$store.dispatch("customer/addCustomerTicket", {
          id: this.$route.params.id,
          data: formData,
        });
        this.ticket = { ...ticketObj };
        this.ticketPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket created Successfully!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getUserByTeam() {
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          (error &&
            error.message &&
            error.message.errors[0] &&
            error.message.errors[0].defaultUserMessage) ||
            `Api failed with status code: ${
              error && error.message && error.message.httpStatusCode
            }`
        );
      }
    },
    getSwapTemplate() {
      this.$store.dispatch("customer/getSwapTemplate");
    },
    async serialNumberCheck3() {
      if (this.oldDeviceItem.itemId) {
        await this.$store.dispatch("customer/setItemDetailsByQuery2", {
          item: this.oldDeviceItem.itemId,
          loc: this.clientDetail.accountInfo.office.id,
          sl: this.deviceSwap.newSerialNo,
        });
        if (this.deviceSwap.newSerialNo && this.deviceSwap.newSerialNo != "") {
          await this.$store.dispatch("customerActivation/setItemDetails", {
            loc: this.clientDetail.accountInfo.office.id,
            sl: this.deviceSwap.newSerialNo,
          });
          this.activation.itemType = this.itemDetail.itemCode;
          this.activation.unitPrice = this.itemDetail.unitPrice;
          this.deviceSwap.unitPrice = this.itemDetail.unitPrice;
          this.deviceSwap.totalPrice = this.itemDetail.unitPrice;
          this.deviceSwap.itemId = this.itemDetail.itemMasterId;
          this.deviceSwap.type = this.itemDetail.itemCode;
          this.deviceSwap.clientId = this.$route.params.id;
          this.deviceSwap.clientServiceId = this.clientServiceId;
          this.deviceSwap.newPSerialNo = this.deviceSwap.newSerialNo;
          this.deviceSwap.oldPSerialNo = this.oldDeviceItem.serialNo;
          this.deviceSwap.orderId = this.oldDeviceItem.id;
          this.deviceSwap.oldSerialNo = this.oldDeviceItem.serialNo;
        }
      }
    },
    async swapDeviceFunc() {
      try {
        if (
          !this.externalSimInfo ||
          !this.externalSimInfo.data.subsInfo ||
          !this.externalSimInfo.data.subsInfo.length ||
          !this.searchSwapSerialNumberInfo ||
          !this.searchSwapSerialNumberInfo.InventoryInfo ||
          !this.searchSwapSerialNumberInfo.InventoryInfo.length
        ) {
          this.$swal({
            title: "Error",
            icon: "error",
            text: "Required SIM or Inventory information is missing.",
            type: "error",
          });
          return;
        }

        const currentStateStr =
          this.externalSimInfo.data.subsInfo[0].currentState;
        const slcStatusMap = {
          1: "IDLE",
          2: "ACTIVE",
          3: "AWAIT_ACTIVATION",
          4: "AWAIT_FIRST_ACTIVATION",
          5: "SUSPENDED_S1",
          6: "DISABLED_S2",
          7: "RETIRED_S3",
          8: "EXPIRED_S4",
          9: "FRAUD_LOCKOUT",
          10: "PENDING",
          11: "BARRED",
          12: "DEACTIVATED",
          13: "Active-Grace",
          14: "Grace-Period-1",
          15: "Grace-Period-2",
        };

        const slcState = Number(
          Object.keys(slcStatusMap).find(
            (key) => slcStatusMap[key] === currentStateStr
          )
        );

        let payload = {
          clientId: this.$route.params.id,
          msisdn: this.oldDeviceItem.mobileNo.msisdn,
          oldSIMNo: this.oldDeviceItem.mobileNo.imsi,
          newSIMNo: this.searchSwapSerialNumberInfo.InventoryInfo[0].unitNo,
          ICCID: this.searchSwapSerialNumberInfo.InventoryInfo[0].unitNo,
          IMSI: [this.searchSwapSerialNumberInfo.InventoryInfo[0].imsi],
          cosId: this.externalSimInfo.data.subsInfo[0].cosId,
          valDate: this.externalSimInfo.data.subsInfo[0].validityDate,
          slcState: slcState,
          tempBlock: this.externalSimInfo.data.subsInfo[0].tempBlocked,
        };
        const response = await this.$store.dispatch(
          "customer/swapSimAction",
          payload
        );

        if (
          response.data &&
          response.data.resourceIdentifier &&
          response.data.resourceIdentifier.includes("Inventory API failed")
        ) {
          this.$swal({
            title: "Error",
            icon: "error",
            text: response.data.resourceIdentifier,
            type: "error",
          });
          this.swapPopup = false;
          return;
        }
        this.swapPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Device Swapped Successfully!",
          type: "success",
        });
        this.getClient();
        this.simSearch = "";
        this.externalSimInfo = null;
        this.searchSwapSerialNumberInfo = null;
        this.uploadedDocuments = [];
        this.oldDeviceItem = {};
        this.deviceSwap = { ...swapObj };
      } catch (e) {
        this.swapPopup = false;
        this.errorMessage =
          e.message.errors && e.message.errors[0]
            ? e.message.errors[0].defaultUserMessage.replace(
                "The parameter",
                ""
              )
            : "Unknown error occurred";
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async orderChargeFunc() {
      try {
        this.orderCharging.systemDate = moment(
          this.orderCharging.systemDate
        ).format("YYYY-MM-DD HH:mm:ss");
        const payload = {
          id: this.$route.params.id,
          data: this.orderCharging,
        };
        this.orderChargingPopup = false;
        await this.$store.dispatch("customer/orderChargingAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Order Charging Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage;
        this.$swal({
          title: "Error",
          icon: "error",
          text: this.errorMessage,
          type: "error",
        });
      }
    },
    async getPriceDetail(id) {
      let res = await this.$store.dispatch("customer/planDetailsAction", id);
      if (
        res.data &&
        res.data.subscriptiondata.length &&
        res.data.subscriptiondata[0].priceId
      ) {
        this.currentPriceId = res.data.subscriptiondata[0].priceId;
      }
    },
    async renewalFunc() {
      try {
        // let payload = {
        //   dateFormat: "dd MMMM yyyy",
        //   dealPoId: "0",
        //   planPoId: this.currentPlan.planCode,
        //   description: this.renewalDescription,
        //   disconnectionDate: moment().format("DD MMMM YYYY"),
        //   locale: "en",
        //   orderNo: this.currentPlan.orderNo,
        //   // priceId: this.currentPriceId,
        //   renewalPeriod: this.currentPlan.contractPeriodId,
        // };

        let newPayload = {
          renewalPeriod: this.currentPlan.contractPeriodId,
          description: this.renewalDescription,
        };
        await this.$store.dispatch("customer/renewalAction", {
          id: this.currentPlan.orderId,
          data: newPayload,
        });
        this.renewalPlanPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Renewal Successful!",
          type: "success",
        });
        this.getClient();
        this.currentPriceId = 0;
        this.renewalDescription = "";
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
      }
    },
    async renewalFunc1(item) {
      try {
        let payload = {
          dateFormat: "dd MMMM yyyy",
          dealPoId: "0",
          planPoId: item.planCode,
          description: item.planDescription,
          disconnectionDate: moment().format("DD MMMM YYYY"),
          locale: "en",
          orderNo: item.orderNo,
          priceId: item.price,
          renewalPeriod: item.contractPeriod,
        };
        await this.$store.dispatch("customer/renewalAction", {
          id: item.orderId,
          data: payload,
        });
        this.openRenewal = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Renewal Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
      }
    },
    async redeemFunc() {
      try {
        this.redeem.clientId = this.$route.params.id;
        this.redeem.officeId =
          (this.clientDetail &&
            this.clientDetail.accountInfo &&
            this.clientDetail.accountInfo.office &&
            this.clientDetail.accountInfo.office.id) ||
          "";
        this.redeem.MSISDN =
          (this.clientDetail && this.clientDetail.hwSerialNumber) || "";
        this.redeemPopup = false;
        await this.$store.dispatch("customer/redeemVoucherAction", this.redeem);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Redeem Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.redeemPopup = false;
        this.errorMessage = e.message.errors[0].defaultUserMessage;
        this.$swal({
          title: "Error",
          icon: "error",
          text: this.errorMessage,
          type: "error",
        });
      }
    },
    async depositFunc() {
      try {
        const payload = {
          clientId: this.$route.params.id,
          feeId: this.deposits,
        };
        this.depositPopup = false;
        await this.$store.dispatch("customer/depositTemplateAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Deposit Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage;
        this.$swal({
          title: "Error",
          icon: "error",
          text: this.errorMessage,
          type: "error",
        });
      }
    },
    async recieverFunc() {
      const receiverClientId = this.reciverId.replace(/[^0-9]*0*(\d+)/, "$1");
      try {
        const payload = {
          senderClientId: this.$route.params.id,
          receiverClientId: receiverClientId,
          amount: this.deposits,
          locale: "en",
        };
        this.recieverPopup = false;
        await this.$store.dispatch("customer/recieverTemplateAction", payload);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Reciever Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage;
        this.$swal({
          title: "Error",
          icon: "error",
          text: this.errorMessage,
          type: "error",
        });
      }
    },
    async updateSpendCap() {
      try {
        const payload = {
          spendCap: parseInt(this.selectedAmount),
        };
        this.spendCapPopup = false;
        await this.$store.dispatch("customer/updateSpendCapAction", {
          data: payload,
          id: this.clientServiceId,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Spend Cap Updated Successful!",
          type: "success",
        });
        this.getClient();
      } catch (e) {
        this.spendCapPopup = false;
        this.errorMessage = e.message.error || e.message;
        await this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong, " + this.errorMessage,
          type: "error",
        });
        this.spendCapPopup = true;
      }
    },
    async updateSpendCapInti() {
      try {
        const payload = {
          spendCap: parseInt(this.selectedAmount),
        };

        await this.$store.dispatch("customer/updateSpendCapAction", {
          data: payload,
          id: this.clientServiceId,
        });

        this.getClient();
      } catch (e) {}
    },
    async changeFile(file) {
      this.bulkUploads.file = file;
    },
    async getDepositList() {
      try {
        await this.$store.dispatch(
          "customer/fetchdepositTemplate",
          this.$route.params.id
        );
      } catch (e) {
        //
      }
    },
    async getProvisioningList() {
      if (
        this.clientDetail &&
        this.clientDetail.services &&
        this.clientDetail.services[0] &&
        this.clientDetail.services[0].id
      ) {
        const serviceId = this.clientDetail.services[0].id;
        await this.$store.dispatch(
          "customer/getProvisioningDetails",
          serviceId
        );
      }
    },
  },
  watch: {
    serviceInfoPopup(newValue) {
      if (!newValue) this.serviceInfo = {};
    },
    changePlanPopup(newval) {
      if (newval) {
        this.getPlanPacks();
      }
    },
    swapPopup(newval) {
      if (newval) {
        this.getSwapTemplate();
      }
      if (!newval) {
        this.simSearch = "";
        this.externalSimInfo = null;
        this.searchSwapSerialNumberInfo = null;
        this.uploadedDocuments = [];
        this.oldDeviceItem = {};
        this.deviceSwap = { ...swapObj };
      }
    },
    redeemPopup(newval) {
      if (newval) {
        this.redeem.pinNumber = "";
      }
    },
    "$route.query.activePage": function (newPage) {
      if (newPage) {
        this.togglePage(Number(newPage));
      }
    },
    async simSearch(newVal) {
      if (newVal.length === 4) {
        try {
          const response = await this.$store.dispatch(
            "customer/getExternalAction",
            this.oldDeviceItem.mobileNo.msisdn
          );
          this.externalSimInfo = response;
        } catch (e) {
          this.externalSimInfo = null;
        }
        await this.searchSwapSerialNumber();
        if (
          this.searchSwapSerialNumberInfo &&
          this.searchSwapSerialNumberInfo.InventoryInfo &&
          this.searchSwapSerialNumberInfo.InventoryInfo.length > 0 &&
          this.searchSwapSerialNumberInfo.InventoryInfo[0].unitNo
        ) {
          this.simSearch =
            this.searchSwapSerialNumberInfo.InventoryInfo[0].unitNo;
        }
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getClient();
    this.clientPlan = moment().format("DD MMMM YYYY");
    if (this.$route.params.moreInfo) {
      this.serviceOrderToggle = false;
      this.moreInfoToggle = true;
    }
    this.getProfilePic();
    if (this.$route.query.activePage) {
      const pageNumber = Number(this.$route.query.activePage);
      this.togglePage(pageNumber);
    }
    this.getProvisioningList();
    this.loading = false;
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
v-select {
  --vs-border-color: #f22 !important;
}
#page-user-view {
  .service-order-tbl {
    td {
      min-width: 102px !important;
    }
  }
}
.popup-example {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
.customer-tab {
  .vs-tabs--content {
    padding-top: 10px;
    &:hover {
      overflow-y: auto;
      transition: 0.2s;
      transition-delay: 0.2s;
    }
  }
}
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
.vs-tabs--content::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: transparent;
}
.vs-tabs--content::-webkit-scrollbar {
  width: 4px;
}
.vs-tabs--content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #7367f0;
}
.liveactive {
  &::after {
    content: "\A";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #00ce00;
    display: inline-block;
  }
}
.vs-sidebar {
  z-index: 9999999;
}
#parentx {
  overflow: hidden;
  height: 500px;
  position: relative;
}
#sidebars-customizer .vs-sidebar {
  max-width: 360px !important;
}
.vs-sidebar .vs-sidebar--items {
  overflow-y: auto;
  overflow-x: hidden;
}
.vs-sidebar--items::-webkit-scrollbar {
  width: 0px;
  background: transparent !important;
}
.header-right-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}
.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.flatpickr-calendar.open {
  z-index: 999999999999;
}
.vs-table--tbody-table {
  min-width: 0px;
}
.abcd {
  display: flex;
  justify-content: space-between;
}
.text-white:hover {
  transform: translate(-10, 5) scale(1.4);
  transition: all;
}
.hover\:text-white:hover .logo-img {
  /* to black */
  filter: grayscale(100%);
  filter: saturate(0%);
  filter: contrast(5%);
  filter: brightness(3);
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}
.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-example table td {
  vertical-align: middle;
}
.service-heading {
  font-size: 1rem;
  color: #333;
  font-weight: 550;
  &:not(:first-child) {
    margin-top: 1rem;
  }
}
.service-heading--large {
  font-size: 2rem;
  margin: 3rem 1rem;
  color: #444;
  font-weight: 550;
}
.routepath {
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  color: #444;
  padding: 1.2rem 0.5rem;
  li {
    position: relative;
  }
  :not(:last-child) {
    color: #444;
    font-weight: 550;
    &::after {
      content: "";
      position: absolute;
    }
  }
  .shift-2 {
    top: 2;
    vertical-align: bottom;
    margin: 0 0.2rem;
  }
}
.form__container {
  position: relative;
  width: 100%;
  height: 10rem;
  border: 2px dashed #bbb5ff;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  color: silver;
  margin-bottom: 5px;
  background: #e9e7ff;
  border-radius: 12px;
  border-color: #bbb5ff;
  padding: 2rem 0;
  .status {
    position: absolute;
    bottom: 1rem;
    font-size: 0.8rem;
    text-align: center;
    display: block;
    width: 100%;
  }
  .remove-icon {
    position: absolute;
    top: 0.3rem;
    right: 0.3rem;
    color: red;
    display: block;
    background: #f7f7f7;
    width: 25px;
    height: 25px;
    box-shadow: 2px 1px 1px #bebebe;
    text-align: center;
    border-radius: 50%;
    z-index: 10;
    .feather-icon {
      display: inline;
      vertical-align: middle;
    }
  }
}
.form__file {
  position: absolute;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  cursor: pointer;
  opacity: 0;
}
.form__container img {
  margin: 0 auto;
  padding-bottom: 3rem;
  margin-bottom: 20px;
  display: block;
}
.navigation-button-lay .vs-con-dropdown {
  width: 100%;
}
.error {
  color: red;
  margin: 0 1rem 1rem 1rem;
}
.md\:w-1\/5 {
  width: 22% !important;
}
.md\:w-4\/5 {
  width: 78% !important;
}
.my-label {
  width: calc(100% - 30px);
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.box {
  inline-size: 105px;
  overflow-wrap: break-word;
}
.card-content {
  word-wrap: break-word;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-warning {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.product-order-status.vs-chip-dark {
  background: #eee !important;
  border: 1px solid #000;
  color: #000 !important;
}
.product-order-status.vs-chip-orange {
  background: #fff !important;
  border: 1px solid #ffa500;
  color: #ffa500 !important;
}
.profilePic {
  height: 100px;
  width: 100px;
  object-fit: cover;
}
.profile-image {
  border: 3px solid;
  border-radius: 50% !important;
  padding: 4px;
  height: 100px;
  width: 100px;
  object-fit: cover;
}
.profile-wrapper {
  display: flex;
  justify-content: space-between;
}
.category-chip {
  min-width: 85px !important;
  min-height: 20px !important;
}
[dir] .vx-row > .vx-col {
  padding: 0 0.75rem;
}
.vs-divider {
  margin: 0 0 15px 0 !important;
}
.popup-width .vs-popup {
  width: 800px !important;
}
.popup2 .vs-popup {
  width: 400px !important;
  min-height: 240px !important;
}
.popup3 {
  overflow: visible !important;
}
.amount-selector {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}
.amount-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  background-color: #f0f9ff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.amount-box:hover {
  box-shadow: 0px 0px 10px 0px #00000033;
}
.amount-box.selected {
  background-color: #e0f7ec;
  border-color: #10b981;
  box-shadow: 0px 0px 10px 0px #00000033;
  color: #047857;
}
</style>
<style scoped>
.popup-big ::v-deep .vs-popup {
  width: 70vw !important;
}
.price-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.old-price {
  font-size: 20px;
  color: #888;
  text-decoration: line-through;
  margin-right: 10px;
}

.current-price {
  font-size: 20px;
  font-weight: 700;
  color: #222;
}
.card-title {
  font-size: 20px;
  font-weight: bold;
  color: #222;
  word-wrap: break-word;
  max-width: 75%;
}
.card-header {
  display: flex;
  gap: 5px;
}
.delete-icon {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 20px;
  height: 20px;
  color: #e74c3c;
}

.delete-icon svg {
  width: 100%;
  height: 100%;
}
.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-label {
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
}

.search-input {
  flex: 1 1 auto;
}
.search-input .vs-input__icon {
  cursor: pointer !important;
}
.product-order-status {
  flex: 0 1 auto;
  min-width: 80px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  left: 70px;
  bottom: 12px;
}
</style>
